/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useTheme } from '@mui/material/styles';
import {Box, Button, CardHeader, Divider, Grid, IconButton, List, ListItem} from '@mui/material';
import SendIcon from '@material-ui/icons/Send';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useDispatch, useSelector } from 'react-redux';

import { getContacts, changeToNumber } from '../../actions'
import { addContact, deleteContact, editContact, sfContacts } from '../../services'
import queryParser from '../../utils/queryParser'
import SearchBar from './SearchBar';
import AddContact from './AddContact';
import EditContact from './EditContact';

export default function Contacts() {
    const theme = useTheme()
    const dispatch = useDispatch()

    const contacts = useSelector(state => state.contacts)

    const queriedNumber = queryParser('number')

    const [name, setName] = React.useState('')
    const [number, setNumber] = React.useState(queriedNumber ? queriedNumber : '')
    const [searchQuery, setSearchQuery] = React.useState('')
    const [visible, setVisible] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [editName, setEditName] = React.useState('')
    const [editNumber, setEditNumber] = React.useState('')
    const [editId, setEditId] = React.useState('')

    useEffect(()=> {
        dispatch(getContacts())
    }, [])

    const handleSubmit = (event) => {
        event.preventDefault()
        setName('')
        setNumber('')
        addContact(
            name, 
            number
        );
    };

    // Edit handlers

    const handleEditSubmit = (event) => {
        event.preventDefault()
        setEditName('')
        setEditNumber('')
        setEditId('')
        setEdit(false)
        editContact(
            editId,
            editName, 
            editNumber,
        );
    };

    // restructure based on dashboard layout
    return (
        <Box
        container
        boxShadow={3}
        spacing={3}
        sx={{width: '39vw', height: '86vh'}}
        >
            <EditContact
                open={edit}
                handleClose={()=> setEdit(false)}
                name={editName}
                number={editNumber}
                setName={setEditName}
                setNumber={setEditNumber}
                handleSubmit={handleEditSubmit}
            />
            <Box>
                <Button 
                color="secondary" 
                onClick={()=> setVisible(!visible)}
                variant="outlined"
                >
                    {visible ? 'Hide' : 'Add Contact'}
                </Button>
                <Button 
                color="secondary" 
                onClick={()=> sfContacts()}
                variant="outlined"
                >
                    Refetch SF Contacts
                </Button>
            </Box>
            { (visible || queriedNumber) && (
                <AddContact
                    name={name}
                    number={number}
                    setName={setName}
                    setNumber={setNumber}
                    handleSubmit={handleSubmit}
                />
            )}
            <Divider 
            flexItem
            sx={{
                border: '1px solid',
                width: '85%',
                mx: 'auto',
                mt: 2
            }}
            />
            <Grid
            container
            direction="column"
            alignItems="center"
            justify="center"
            sx={{
                background: theme.palette.primary.dark,
            }}
            >
                <Box sx={{ mx: 'auto', marginTop: '10px' }}>
                    <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery}/>
                </Box>
                <List
                sx={{
                    height: visible ? '35vh' : '70vh',
                    overflowY: 'auto'
                }}>
                    {contacts?.filter(e => e.name.toLowerCase().match(new RegExp(searchQuery.toLowerCase())))
                        .map((element, index) => {
                            return (
                            <ListItem key={index}>
                                <AccountCircleIcon fontSize='large'/>
                                <CardHeader 
                                title={element.name}
                                subheader={element.number}
                                sx={{
                                    background: 'transparent',
                                }}
                                />
                                <IconButton 
                                aria-label="respond"
                                color="secondary"
                                onClick={()=> dispatch(changeToNumber(element.number))}
                                >
                                    <SendIcon />
                                </IconButton>
                                <IconButton 
                                aria-label="respond"
                                color="secondary"
                                onClick={()=> {
                                    setEdit(true)
                                    setEditId(element._id)
                                    setEditName(element.name)
                                    setEditNumber(element.number)
                                }}
                                >
                                    <EditIcon />
                                </IconButton>
                                <IconButton 
                                aria-label="delete"
                                color="error"
                                onClick={()=> deleteContact(element._id)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </ListItem>
                        )})	
                    }
                </List>
            </Grid>
        </Box>
    )
}